import { Field } from 'formik';
import * as React from 'react';

import { DatePickerProps } from './types';
import ErrorMessage from '../ErrorMessage';
import muiStyles from '../fieldStyles';

export default function DatePicker(props: DatePickerProps) {
    const {
        name,
        label,
        placeholder,
        withTime,
        disabled,
        errors
    } = props;

    const classes = muiStyles(props);

    return (
        <Field
            name={name}
            type='text'
        >
            {({ field, form }) => (
                <div className={classes.field}>
                    <label
                        className={classes.inputLabel}
                        htmlFor={name}
                    >
                        {label}
                    </label>
                    <input
                        {...field}
                        className={classes.textInput}
                        disabled={disabled}
                        max={withTime ? '9999-12-31T23:59' : '9999-12-31'}
                        name={name}
                        placeholder={placeholder}
                        type={withTime ? 'datetime-local' : 'date'}
                    />
                    <ErrorMessage
                        error={errors[field.name]}
                        field={field}
                        form={form}
                    />
                </div>
            )}
        </Field>
    );
}